export interface TrackingDataForProduct {
  product_id: string;
  name: string;
  core_product_id: string;
  core_product_version: number;
}

export function createTrackingDataForProduct({
  mpvId,
  productName,
  productKey,
  productVersion,
}: {
  mpvId: string;
  productName: string;
  productKey: string;
  productVersion: number;
}): TrackingDataForProduct {
  return {
    product_id: mpvId,
    name: productName,
    core_product_id: productKey,
    core_product_version: productVersion,
  };
}
